// Module
var code = "<div class=\"t-popout c-popout\">\n    <div class=\"c-tooltip u-p+\">\n        <div ng-repeat=\"item in context.list\" ng-bind=\"::item\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;